import React, {Component} from 'react';
import classnames from "classnames";
import {Breadcrumb, BreadcrumbItem, Col, Container, Nav, NavItem, NavLink, Row, TabContent, TabPane} from "reactstrap";
import {Link} from "react-router-dom";
import UserPanelMenu from "../../components/user/UserPanelMenu";
import MerchantForm from "../../components/merchants/MerchantForm";

export default class UserMerchantAdd extends Component {
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
        this.state = {
            activeTab: '1',
            is_enable:false
        };
    }

    toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }
    render() {
        return (
            <div className="pt-3">
                <Container>
                    <Breadcrumb className='w-100 white rounded mt-3 rtl'>
                        <BreadcrumbItem><Link to="/">خانه</Link></BreadcrumbItem>
                        <BreadcrumbItem><Link to="/users">کاربر</Link></BreadcrumbItem>
                        <BreadcrumbItem active> صفحه کاربری</BreadcrumbItem>
                    </Breadcrumb>
                    <Row className='mt-3 md-5 rtl'>
                        <Col md='3' sm='12' className="">
                            <UserPanelMenu activeElement="4"/>
                        </Col>
                        <Col md='9' sm='12'>
                            <div className="panel panel-default white">
                                <div className="portlet-title">
                                    <Nav tabs>
                                        <NavItem>
                                            <NavLink
                                                className={classnames({ active: this.state.activeTab === '1' })}
                                                onClick={() => { this.toggle('1'); }}
                                            >
                                                اطلاعات پایه
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                className={classnames({ active: this.state.activeTab === '2' })}
                                                onClick={() => { this.toggle('2'); }}
                                                disabled={!this.state.is_enable}
                                            >
                                                گالری تصاویر
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                className={classnames({active: this.state.activeTab === '3'})}
                                                onClick={() => {
                                                    this.toggle('3');
                                                }}
                                                disabled={!this.state.is_enable}
                                            >
                                                خرید بسته و فعال سازی
                                            </NavLink>
                                        </NavItem>

                                    </Nav>
                                </div>
                                <div className="portlet-body p-3">
                                    <TabContent activeTab={this.state.activeTab}>
                                        <TabPane tabId="1">
                                           <MerchantForm />
                                        </TabPane>
                                        <TabPane tabId="2">
                                            tab2
                                        </TabPane>
                                        <TabPane tabId="3">
                                            tab3
                                        </TabPane>

                                    </TabContent>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/containers/merchants/UserMerchantAdd.js